@use "variables" as *;

.textArea {
  font-size: $fontSize-m;
  font-weight: bold;
  border-style: solid;
  border-width: thin;
  border-radius: 12px;
  min-height: 200px;
  max-width: 98%;
  padding: 6px;
  font-family: sans-serif;
}
